import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status","result","orgId","dsUid","cookie","from","to","rangeBadge"]

  connect() {
    this.sourceId = null
    this.now = () => Date.now()
    this.rangeDays(7)
    this.refreshStatus()
  }

  csrf() {
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.content : ""
  }

  // Ranges
  range7d(e){ e?.preventDefault(); this.rangeDays(7) }
  range30d(e){ e?.preventDefault(); this.rangeDays(30) }
  rangeDays(days){
    const to = this.now(), from = to - days*24*3600*1000
    this.fromTarget.value = String(Math.floor(from))
    this.toTarget.value   = String(Math.floor(to))
    if (this.hasRangeBadgeTarget) this.rangeBadgeTarget.textContent = `${days}j`
  }

  async refreshStatus(){
    this.setStatus("Chargement…")
    const r = await fetch("/teslamate_sources/status", { credentials:"same-origin" })
    const j = await r.json()
    if (j.exists){ this.sourceId=j.id; this.setStatus(`Source #${j.id} chargée.`) }
    else { this.setStatus("Aucune source configurée.") }
  }

  async save(e){
    e?.preventDefault()
    this.setStatus("Enregistrement…")
    const payload = { teslamate_source: {
      org_id: this.orgIdTarget.value.trim(),
      ds_uid: this.dsUidTarget.value.trim(),
      cookie: this.cookieTarget.value.trim()
    } }
    const r = await fetch("/teslamate_sources", {
      method:"POST", credentials:"same-origin",
      headers:{ "Content-Type":"application/json","Accept":"application/json","X-CSRF-Token":this.csrf() },
      body: JSON.stringify(payload)
    })
    const j = await r.json().catch(()=>({}))
    this.log(JSON.stringify(j,null,2))
    if(r.ok && j.ok){ this.sourceId=j.id; this.setStatus(`Source #${j.id} enregistrée.`) }
    else { this.setStatus(`Erreur: ${j.error || r.status}`) }
  }

  async test(e){
    e?.preventDefault()
    if(!this.sourceId) return this.setStatus("Configurez d'abord la source.")
    this.setStatus("Test en cours…")
    const r = await fetch("/teslamate_sources/test", {
      method:"POST", credentials:"same-origin",
      headers:{ "Content-Type":"application/json","Accept":"application/json","X-CSRF-Token":this.csrf() },
      body: JSON.stringify({})
    })
    const j = await r.json().catch(()=>({}))
    this.log(JSON.stringify(j,null,2))
    if(r.ok && j.ok) this.setStatus(`Test OK: ${j.cars?.length||0} véhicule(s).`)
    else this.setStatus(`Test KO: ${j.error || r.status}`)
  }

  async rotate(e){
    e?.preventDefault()
    if(!this.sourceId) return this.setStatus("Configurez d'abord la source.")
    this.setStatus("Rotation du token…")
    const r = await fetch("/teslamate_sources/rotate", {
      method:"POST", credentials:"same-origin",
      headers:{ "Content-Type":"application/json","Accept":"application/json","X-CSRF-Token":this.csrf() }
    })
    const j = await r.json().catch(()=>({}))
    this.log(JSON.stringify(j,null,2))
    if(r.ok && j.ok){ this.setStatus("Token rotaté ✓") } else { this.setStatus(`Erreur: ${j.error||r.status}`) }
  }

  async linkCars(e){
    e?.preventDefault()
    if(!this.sourceId) return this.setStatus("Configurez d'abord la source.")
    this.setStatus("Lien des véhicules…")
    const r = await fetch("/teslamate_sources/link_cars", {
      method:"POST", credentials:"same-origin",
      headers:{ "Content-Type":"application/json","Accept":"application/json","X-CSRF-Token":this.csrf() }
    })
    const j = await r.json().catch(()=>({}))
    this.log(JSON.stringify(j,null,2))
    if(r.ok && j.ok){ this.setStatus(`Véhicules liés: ${j.result.linked}`) } else { this.setStatus(`Erreur: ${j.error||r.status}`) }
  }

  async importDrives(e){
    e?.preventDefault()
    if(!this.sourceId) return this.setStatus("Configurez d'abord la source.")
    const body = { from_ms: Number(this.fromTarget.value), to_ms: Number(this.toTarget.value), async: false }
    this.setStatus("Import des trajets…")
    const r = await fetch("/teslamate_sources/import_drives", {
      method:"POST", credentials:"same-origin",
      headers:{ "Content-Type":"application/json","Accept":"application/json","X-CSRF-Token":this.csrf() },
      body: JSON.stringify(body)
    })
    const j = await r.json().catch(()=>({}))
    this.log(JSON.stringify(j,null,2))
    if(r.ok && j.ok){ this.setStatus("Import trajets terminé ✓") } else { this.setStatus(`Erreur: ${j.error||r.status}`) }
  }

  async importPositions(e){
    e?.preventDefault()
    if(!this.sourceId) return this.setStatus("Configurez d'abord la source.")
    const body = { from_ms: Number(this.fromTarget.value), to_ms: Number(this.toTarget.value), async: false }
    this.setStatus("Import des positions…")
    const r = await fetch("/teslamate_sources/import_positions", {
      method:"POST", credentials:"same-origin",
      headers:{ "Content-Type":"application/json","Accept":"application/json","X-CSRF-Token":this.csrf() },
      body: JSON.stringify(body)
    })
    const j = await r.json().catch(()=>({}))
    this.log(JSON.stringify(j,null,2))
    if(r.ok && j.ok){ this.setStatus("Import positions terminé ✓") } else { this.setStatus(`Erreur: ${j.error||r.status}`) }
  }

  // helpers
  setStatus(text){ if(this.hasStatusTarget) this.statusTarget.textContent = text }
  log(text){ if(this.hasResultTarget) this.resultTarget.textContent = text }
}
